import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { Subscription } from 'rxjs';
import { EventService } from '../event.service';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { TimeService } from '../time.service';
import { ValidationService } from '../validation.service';
import { StorageService } from '../storage.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  carrierId: Subscription;
  vehicleFilters: any = {};
  selectedVehicles = [];
  selectedVehicleNumber: any = {};
  showLoader = false;
  selectedShipperOnly = false;
  locationsArray: any = [];
  selectedPickups = [];
  selectedDeliveries = [];
  allShippers: any = [];
  selectShipper: any = {};
  filterFrom = '';
  filterTo = '';
  etaPerformanceCompliance = false;
  etaPerformanceReport = false;
  showPickDrop = true;
  onlyFromTo = false;
  epodStatus = false;
  nonPlacement = false;
  consent = false;
  vehicleData = {
    maintenance: false,
    in_shipment: false,
  };

  reportRequest = {
    url: '',
    delay_buffer: '',
    epods_available: false
  };
  fromDate: any;
  toDate: any;
  epodReportStatus = 'all';
  reportTypes: any[] = [
    {
      name: 'heading_orders',
      groupValues: [
        {
          name: 'non_placement',
          value: 'non_placement_carrier'
        },

      ]
    },
    {
      name: 'heading_shipments',
      groupValues: [
        {
          name: 'consent_report',
          value: 'consent_report_carrier'
        },
        {
          name: 'compliance',
          value: 'etaPerformanceCompliance',
        },
        {
          name: "etaPerformanceReport",
          value: "etaPerformanceReport",
        },
        {
          name: "exited_vehicles",
          value: "exitedVehicle",
        },
        {
          name: 'epods',
          value: 'epods_carrier'
        },
      ]
    },
  ]
  reportStatus = [{
    name: 'All',
    value: 'all'
  },
  {
    name: 'Shipments with EPod(s)',
    value: 'epods_carrier'
  },
  {
    name: 'Shipment without EPod(s)',
    value: 'no_epods'
  },
  ];
  selectedShipperId: any;
  shippers: any;
  etaReport = false;

  constructor(private http: HttpService, private snackbar: SnackbarService, private valid: ValidationService,
    private timeService: TimeService, private translation: TranslateService, private events: EventService, private storage: StorageService) { }

  ngOnInit() {
    this.getFilters();
    this.getShippers();
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.resetAll();
        this.getFilters();
        this.getShippers();
      },
      (err: any) => {
        console.log('Err ::', err);
      }
    );
  }

  resetAll() {
    this.selectedShipperOnly = false;

    this.locationsArray = [];
    this.selectedPickups = [];
    this.selectedDeliveries = [];
    this.allShippers = [];
    this.selectShipper = {};
    this.selectedVehicleNumber = {};
    this.filterFrom = '';
    this.filterTo = '';
    this.showPickDrop = true;
    this.reportRequest = {
      url: '',
      delay_buffer: '',
      epods_available: false
    };
    this.fromDate = '';
    this.toDate = '';
    this.epodReportStatus = 'all';
    this.selectedVehicles = [];
    this.selectedVehicleNumber = [];
    this.epodStatus = false;
    this.consent = false;
  }
  getFilters() {
    this.showLoader = true;
    this.http.get('shipment/get_filter').subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.showLoader = false;
          this.locationsArray = response.data.locations || [];
        }
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }

  getShippers() {
    this.showLoader = true;
    const query = {
      exclude_uvf: true,
      exclude_blocked: true,
    };
        this.http.get('shippers').subscribe(
          (data: any) => {
            if (data.statusCode === 200) {
              const shippers = data.data;
              shippers.forEach(element => {
                const temp: any = {};

          temp._id = element._id;
          temp.name = element.name;
          temp.parentName = element.parent_name;
          temp.reference = (element.erp_reference && element.erp_reference.length) ?
            (element.erp_reference[0].reference_id) ? element.erp_reference[0].reference_id + ' - ' : '' : '';
          this.allShippers.push(temp);
              })
              this.showLoader = false;
            }
              },
              (err: any) => {
                this.snackbar.openSnackBar(err.error.message, '', 'err');
              }
            );
  }

  selectType(report, event) {
    // this.selectedShipperOnly = false;
    if (report.name === "etaPerformanceReport" || report.name === "compliance") this.etaReport = true;
    else this.etaReport = false;
    this.vehicleData = {
      maintenance: false,
      in_shipment: false,
    };
    this.selectedPickups = [];
    this.selectedDeliveries = [];
    this.fromDate = '';
    this.toDate = '';
    this.selectedVehicles = [];
    this.epodReportStatus = 'all';

    this.reportRequest = {
      url: '',
      delay_buffer: '',
      epods_available: false
    };
    this.selectedVehicleNumber = {};

    if (event.source._selected) {
      this.reportRequest.url = report.value;
      this.showPickDrop = ( report.value == 'non_placement_carrier'|| report.value == "etaPerformanceCompliance" || report.value == "etaPerformanceReport" || report.value == 'delivery_epods') ? false : true;
      this.onlyFromTo = ( report.value == 'daily_Epodstatus_email') ? true : false;
      this.epodStatus = (report.value == 'daily_Epodstatus_email') ? true : false;
      this.nonPlacement = (report.value == 'non_placement_carrier') ? true : false;
      this.consent = (report.value == 'consent_report_carrier') ? true : false;
      this.etaPerformanceReport = report.value == "etaPerformanceReport" ? true : false;
      this.etaPerformanceCompliance = report.value == "etaPerformanceCompliance" ? true : false;
    }

    if(this.reportRequest.url === 'exitedVehicle') {
      this.showPickDrop = false
    }
  }

  selectStaus(status, event) {
    if (event.source._selected) {
      this.epodReportStatus = status.value;
    }
  }

  generateReport() {
    console.log('this',this.fromDate);
    if (!this.reportRequest.url) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.REPORTS.VALID.REPORT_TYPE'), '', 'err');
      return false;
    } else if (this.reportRequest.url != 'vehicle_service' && this.reportRequest.url != 'daily_Epodstatus_email' && this.reportRequest.url != 'user_usage_report' && this.reportRequest.url != 'non_placement_carrier' && (!this.fromDate || !this.toDate && this.reportRequest.url != "etaPerformanceReport" && this.reportRequest.url != "etaPerformanceCompliance")) {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.REPORTS.VALID.DATES'), '', 'err');
      return false;
    }
    if(this.fromDate == '' || this.toDate == '') {
      this.snackbar.openSnackBar(this.translation.instant('MESSAGE.REPORTS.VALID.DATES'), '', 'err');
      return false;
    }
    const request: any = {};
      const from: any = DateTime.fromJSDate(this.fromDate).startOf('day').toUTC();
      const to: any = DateTime.fromJSDate(this.toDate).endOf('day').toUTC();

      request.from = from.ts;
      request.to = to.ts;

    if (this.reportRequest.url == 'epods_carrier') {
      if (!this.epodReportStatus) {
        this.snackbar.openSnackBar(this.translation.instant('MESSAGE.REPORTS.VALID.STATUS_TYPE'), '', 'err');
        return false;
      }
      delete this.reportRequest.delay_buffer;
      console.log('this--',this.epodReportStatus);
      if (this.epodReportStatus == 'all') {
        delete this.reportRequest.epods_available;
      } else {
        this.reportRequest.epods_available = this.epodReportStatus == 'epods_carrier';
        request.epods_available = this.reportRequest.epods_available;
      }
    } 
    if (this.reportRequest.url == "etaPerformanceReport") {
      request.all = !this.selectedShipperOnly;
    }else {
      delete request.all;
    }
    if (this.selectShipper && this.selectShipper._id) {
      request.shipper = this.selectShipper._id;
    }

    if (this.nonPlacement && this.selectedShipperId) {
      request.shipper = this.selectedShipperId;
    }
    this.showLoader = true;
    const url = (!this.selectedShipperOnly && !this.onlyFromTo  && !this.nonPlacement && !this.consent && !this.etaPerformanceReport && !this.etaPerformanceCompliance) ? this.reportRequest.url + '/all' : this.reportRequest.url;
    // const url = this.reportRequest.url;

    this.http.post('v1/reports/' + url, request, 2).subscribe(
      (response: any) => {
        this.showLoader = false;
        this.onlyFromTo = false;
        this.selectedShipperOnly = false;
        this.showPickDrop = false;
        window.open(response.data.link, '_blank');
        this.reportRequest = {
          url: '',
          epods_available: false,
          delay_buffer: ''
        };
        this.fromDate = '';
        this.toDate = '';
        this.selectedVehicles = [];
        this.selectedVehicleNumber = [];
        this.nonPlacement = false;
        this.selectedShipperId = '';
        this.selectShipper = {};
      },
      (err: any) => {
        this.showLoader = false;
        this.snackbar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }

  selectVehicleType(vehicle, event) {
    if (event.source._selected) {
      if (this.selectedVehicles.indexOf(vehicle._id) == -1) {
        this.selectedVehicles.push(vehicle._id);
      }
    } else if (!event.source._selected) {
      if (this.selectedVehicles.indexOf(vehicle._id) > -1) {
        this.selectedVehicles.splice(this.selectedVehicles.indexOf(vehicle._id), 1);
      }
    }
  }

  selectedShipper(shipper) {
    this.selectedShipperId = shipper._id;
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

}

